// 1. All imports
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaPhoneAlt, FaEnvelope, FaChevronDown, FaChevronRight, FaBars, FaTimes, FaLinkedin } from "react-icons/fa";
import "../styles/Navbar.css";

// 2. Data constants
const knowledgeMenu = [
  "Calculators", "Utilities", "Links",
]; //"Bulletins","Acts", "Rules", "Forms"



const knowledgeLinksSubmenu = [
  "GST/VAT Links",
  "Important Links"
];

const SocialIcon = ({ icon, href }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" style={{
    backgroundColor: "#eff6ff",
    padding: "10px",
    borderRadius: "8px",
    color: "#2563eb",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}>
    {icon}
  </a>
);

export default function Navbar() {
  const [showKnowledgeDropdown, setShowKnowledgeDropdown] = useState(false);
  const [showLinksSubMenu, setShowLinksSubMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isPhoneHovered, setIsPhoneHovered] = useState(false);
  const [isEmailHovered, setIsEmailHovered] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);


  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = () => {
      if (showKnowledgeDropdown) {
        setShowKnowledgeDropdown(false);
        setShowLinksSubMenu(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showKnowledgeDropdown]);

  const toggleKnowledgeDropdown = (e) => {
    e.stopPropagation();
    setShowKnowledgeDropdown(!showKnowledgeDropdown);
    setShowLinksSubMenu(false);
  };

  const closeAllMenus = () => {
    setSidebarOpen(false);
    setShowKnowledgeDropdown(false);
    setShowLinksSubMenu(false);
  };



  // Main Bar Links Style (Updated color to blue/dark since background is white)
  const mainNavLinkStyle = {
    color: "#0f2b46",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "700",
    letterSpacing: "0.5px",
    transition: "0.3s",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
    padding: "5px 10px"
  };

  const getRevealTextStyle = (isHovered) => ({
    position: "absolute",
    top: "45px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "#0f2b46",
    color: "#ffffff",
    padding: "6px 10px",
    borderRadius: "6px",
    whiteSpace: "nowrap",
    fontSize: "12px",
    fontWeight: "600",
    opacity: isHovered ? 1 : 0,
    pointerEvents: "none",
    transition: "opacity 0.3s ease",
    zIndex: 9999
  });

  return (
    <nav style={{
      width: "100%",
      position: "fixed",
      top: 0,
      zIndex: 2000,
      boxShadow: scrolled ? "0 4px 20px rgba(0,0,0,0.15)" : "0 4px 15px rgba(0,0,0,0.1)",
      transition: "0.4s ease-in-out"
    }} className="main-nav-bar">

      {/* --- MAIN BAR (Logo, Contact Info & Navigation) --- */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "22px 40px",
        height: "auto",// 👈 ONLY THIS LINE ADD
        background: scrolled ? "rgba(255, 255, 255, 0.98)" : "#ffffff",
        backdropFilter: scrolled ? "blur(10px)" : "none",
        transition: "0.4s"
      }}>

        {/* LOGO SECTION */}
        <div onClick={() => { navigate("/"); closeAllMenus(); }} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "14px" }}>
          <div className="logo-text-block">
            <h2 style={{
              margin: 0,
              color: "#0f2b46",
              letterSpacing: "1px",
              fontWeight: "900",
              fontSize: "20px",
              transition: "0.3s"
            }}>
              Manoj V Ayadi & Associates
            </h2>
            <div style={{
              fontSize: "8px",
              color: "#64748b",
              fontWeight: "700",
              textTransform: "uppercase",
              letterSpacing: "2px",
              display: "block",
              textAlign: "center",
            }} className="sub-logo-text">
              Practising Company Secretaries
            </div>

            <div style={{
              fontSize: "10px",
              color: "#0f2b46",
              fontWeight: "600",
              fontStyle: "italic",
              letterSpacing: "0.5px",
              display: "block",
              marginTop: "10px"
            }} className="tagline-text">
              "If you think Compliance is Expensive, Try Non Compliance"
            </div>
          </div>
        </div>

        {/* RIGHT SIDE: CONTACT + NAVIGATION */}
        {/* RIGHT SIDE: CONTACT + NAVIGATION */}
        <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>

          {/* 1. Contact Info Section */}
          <div className="contact-info-section" style={{ display: "flex", gap: "20px" }}>
            {/* LinkedIn & Twitter - PEHLE */}
            <SocialIcon icon={<FaLinkedin />} href="https://www.linkedin.com/in/cs-manoj-ayadi-a745b51a3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" />
            <a href="https://x.com/pcsmanoj?s=21" target="_blank" rel="noopener noreferrer" style={{
              backgroundColor: "#eff6ff",
              padding: "10px",
              borderRadius: "8px",
              color: "#2563eb",
              fontSize: "14px",
              fontWeight: "900",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              lineHeight: "1"
            }}>
              𝕏
            </a>

            <div onMouseEnter={() => setIsPhoneHovered(true)} onMouseLeave={() => setIsPhoneHovered(false)} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", position: "relative" }}>
              <div style={{ backgroundColor: "#eff6ff", padding: "10px", borderRadius: "8px" }}><FaPhoneAlt style={{ color: "#2563eb", fontSize: "14px" }} /></div>
              <div style={getRevealTextStyle(isPhoneHovered)}>
                +91 97731 12128
              </div>
            </div>
            <div onMouseEnter={() => setIsEmailHovered(true)} onMouseLeave={() => setIsEmailHovered(false)} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", position: "relative" }}>
              <div style={{ backgroundColor: "#eff6ff", padding: "10px", borderRadius: "8px" }}><FaEnvelope style={{ color: "#2563eb", fontSize: "14px" }} /></div>
              <div style={getRevealTextStyle(isEmailHovered)}>
                office@csmanojayadi.com
              </div>
            </div>
          </div>

          {/* 2. Desktop Nav Links */}
          <div className="desktop-nav" style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <Link to="/" style={mainNavLinkStyle}>HOME</Link>
            <Link to="/about" style={mainNavLinkStyle}>ABOUT US</Link>
            <Link to="/services" style={mainNavLinkStyle}>SERVICES</Link>
            <div onClick={toggleKnowledgeDropdown} style={{ ...mainNavLinkStyle, position: "relative", display: "inline-block" }}>
              KNOWLEDGE BANK <FaChevronDown style={{ fontSize: "10px" }} />
              {/* ... (Existing Dropdown Logic) ... */}
              {showKnowledgeDropdown && (
                <div style={{
                  position: "absolute",
                  top: "40px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  background: "#ffffff",
                  width: "150px",
                  borderRadius: "4px",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                  zIndex: 3000,
                  border: "1px solid #eee"
                }}>
                  {knowledgeMenu.map((item, i) => (
                    <div
                      key={i}
                      className="dropdown-item"
                      style={{ padding: "12px 20px", cursor: "pointer", color: "#0f2b46", position: 'relative', borderBottom: "1px solid #f8f9fa", display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (item === "Calculators") navigate("/calculator");
                        else if (item === "Utilities") navigate("/utilities");
                        else if (item === "Links") { setShowLinksSubMenu(!showLinksSubMenu); return; }
                        closeAllMenus();
                      }}
                    >
                      {item}
                      {item === "Links" && <FaChevronRight style={{ fontSize: "10px", marginLeft: "10px" }} />}

                      {item === "Links" && showLinksSubMenu && (
                        <div style={{ position: 'absolute', left: '100%', top: 0, background: '#fff', width: '180px', borderRadius: '4px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', border: "1px solid #eee" }}>
                          {knowledgeLinksSubmenu.map((subItem, j) => (
                            <div
                              key={j}
                              style={{ padding: '10px 15px', color: '#0f2b46', fontSize: '13px', borderBottom: "1px solid #f8f9fa" }}
                              onClick={() => {
                                if (subItem === "GST/VAT Links") navigate("/gst-vat-links");
                                else if (subItem === "Important Links") navigate("/important-links");
                                closeAllMenus();
                              }}
                            >
                              {subItem}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <Link to="/contact" style={mainNavLinkStyle}>CONTACT</Link>
          </div>

          {/* 3. Hamburger Button - Ye desktop par hide rahega CSS ke wajah se */}
          <div
            className="hamburger"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{ fontSize: "24px", cursor: "pointer", color: "#0f2b46", zIndex: 99999 }}
          >
            {sidebarOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </div>


      {/* --- MOBILE SIDEBAR --- */}
      <div className={`mobile-sidebar ${sidebarOpen ? "open" : ""}`} style={{
        position: "fixed", top: 0, right: sidebarOpen ? 0 : "-100%",
        width: "280px", height: "100vh", background: "#fff",
        boxShadow: "-5px 0 15px rgba(0,0,0,0.1)", transition: "0.3s ease-in-out",
        zIndex: 3000, padding: "20px", display: "flex", flexDirection: "column"
      }}>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "30px" }}>
          <FaTimes style={{ fontSize: "24px", cursor: "pointer" }} onClick={() => setSidebarOpen(false)} />
        </div>

        <div className="sidebar-links" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Link to="/" className="sidebar-link" onClick={closeAllMenus} style={{ textDecoration: 'none', color: '#0f2b46', fontWeight: 'bold' }}>HOME</Link>
          <Link to="/about" className="sidebar-link" onClick={closeAllMenus} style={{ textDecoration: 'none', color: '#0f2b46', fontWeight: 'bold' }}>ABOUT US</Link>
          <Link to="/services" className="sidebar-link" onClick={closeAllMenus} style={{ textDecoration: 'none', color: '#0f2b46', fontWeight: 'bold' }}>SERVICES</Link>

          <div className="sidebar-dropdown">
            {/* Header Section: Text alag aur Arrow alag */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold', color: '#0f2b46' }}>
              <span style={{ cursor: 'default' }}>KNOWLEDGE BANK</span>

              {/* Sirf is Icon par click karne se dropdown khulega */}
              <FaChevronDown
                style={{
                  cursor: "pointer",
                  padding: "5px",
                  fontSize: "20px", // Thoda size badhaya clarity ke liye
                  color: "#071a2d", // Darker Blue / Blackish color
                  marginLeft: "10px", // Right shift karne ke liye space
                  transition: "0.3s",
                  transform: showKnowledgeDropdown ? "rotate(180deg)" : "rotate(0deg)"
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Parent click prevent karne ke liye
                  setShowKnowledgeDropdown(!showKnowledgeDropdown);
                }}
              />
            </div>

            {showKnowledgeDropdown && (
              <div style={{ paddingLeft: "15px", marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px" }}>
                {knowledgeMenu.map((item, i) => (
                  <div key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: "12px 0"
                    }}>

                      {/* 1. Item Text (Calculators/Utilities etc. par click navigate karega) */}
                      <span
                        style={{
                          cursor: 'pointer',
                          flex: 1,
                          fontSize: "14px",
                          color: "#0f2b46",
                          fontWeight: "500"
                        }}
                        onClick={() => {
                          if (item === "Calculators") {
                            navigate("/calculator");
                            closeAllMenus();
                          }
                          else if (item === "Utilities") {
                            navigate("/utilities");
                            closeAllMenus();
                          }
                          else if (item === "Links") {
                            // Mobile mein 'Links' text par click karne se bhi submenu toggle ho sakta hai
                            setShowLinksSubMenu(!showLinksSubMenu);
                          }
                          else {
                            navigate(`/${item.toLowerCase()}`);
                            closeAllMenus();
                          }
                        }}
                      >
                        {item}
                      </span>

                      {/* 2. Arrow Icon (Sirf 'Links' ke liye toggle handle karega) */}
                      {item === "Links" && (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowLinksSubMenu(!showLinksSubMenu);
                          }}
                          style={{ padding: "5px 10px", cursor: "pointer" }}
                        >
                          <FaChevronDown
                            style={{
                              fontSize: "12px",
                              transition: "0.3s",
                              transform: showLinksSubMenu ? "rotate(180deg)" : "rotate(0deg)",
                              color: "#071a2d",
                            }}
                          />
                        </div>
                      )}
                    </div>

                    {/* 3. Nested Submenu for 'Links' (GST/VAT & Important Links) */}
                    {item === "Links" && showLinksSubMenu && (
                      <div style={{
                        paddingLeft: "20px",
                        paddingBottom: "10px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        borderLeft: "2px solid #2563eb",
                        marginLeft: "5px",
                        marginBottom: "10px"
                      }}>
                        {knowledgeLinksSubmenu.map((sub, j) => (
                          <div
                            key={j}
                            onClick={() => {
                              // Sahi page par navigate karna
                              if (sub === "GST/VAT Links") navigate("/gst-vat-links");
                              else if (sub === "Important Links") navigate("/important-links");
                              closeAllMenus(); // Page open hone par sidebar band ho jaye
                            }}
                            style={{
                              fontSize: "13px",
                              color: "#64748b",
                              cursor: "pointer",
                              fontWeight: "500"
                            }}
                          >
                            {sub}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <Link to="/contact" className="sidebar-link" onClick={closeAllMenus} style={{ textDecoration: 'none', color: '#0f2b46', fontWeight: 'bold' }}>CONTACT</Link>
        </div>
      </div>

      {/* Overlay to close sidebar when clicking outside */}
      {sidebarOpen && <div onClick={closeAllMenus} style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.3)", zIndex: 2500 }} />}
    </nav>
  );
}